import { Link } from '@tanstack/react-router'
import { Button } from '@/components/ui/button'
import type { ReactNode } from 'react'

export function EmptyState({
  icon,
  title,
  body,
  cta,
}: {
  icon: ReactNode
  title: string
  body: string
  cta?: { label: string; to: string }
}) {
  return (
    <div className="flex flex-col items-center justify-center text-center py-24 px-8">
      <div className="text-muted-foreground mb-4 [&>svg]:h-8 [&>svg]:w-8">{icon}</div>
      <h2 className="text-sm font-medium text-foreground">{title}</h2>
      <p className="text-xs text-muted-foreground mt-1.5 max-w-md">{body}</p>
      {cta && (
        <Link to={cta.to as never} className="mt-6">
          <Button size="sm">{cta.label}</Button>
        </Link>
      )}
    </div>
  )
}
